"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyProgramRoutingKey = void 0;
var LoyaltyProgramRoutingKey;
(function (LoyaltyProgramRoutingKey) {
    LoyaltyProgramRoutingKey["LoyaltyPointDeltaFromInvoice"] = "loyaltyProgram_LoyaltyPointDeltaFromInvoice";
    LoyaltyProgramRoutingKey["LoyaltyPointGrantByUser"] = "loyaltyProgram_LoyaltyPointGrantByUser";
    LoyaltyProgramRoutingKey["LoyaltyRewardRedemptionRedemptionCancelation"] = "loyaltyProgram_LoyaltyRewardRedemptionRedemptionCancelation";
    LoyaltyProgramRoutingKey["LoyaltyRewardRedemptionRedemptionRequested"] = "loyaltyProgram_LoyaltyRewardRedemptionRedemptionRequested";
})(LoyaltyProgramRoutingKey = exports.LoyaltyProgramRoutingKey || (exports.LoyaltyProgramRoutingKey = {}));
//# sourceMappingURL=types.js.map